import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { SharedModule } from '@shared/shared.module';
import { HomeRoutingModule } from './home.routing';

import { DisclosuresComponent } from './pages/disclosures/disclosures.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';

@NgModule({
  declarations: [DisclosuresComponent, MaintenanceComponent],
  imports: [
    SharedModule,
    HomeRoutingModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatSelectModule,
    CommonModule,
    MatMenuModule,
    FormsModule,
    GoogleMapsModule,
    MatProgressBarModule,
  ],
})
export class HomeModule {}
